(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["orso-discovery-collection-card"] && !Shopify.designMode) return;
  try {
    function discoveryChoicePair(record, selectedId, baseUrl = globalThis.location?.href) {
  const raw = ['white', 'black'].map((key) => record?.[key]).filter(Boolean);
  const entries = raw.map((entry) => {
    if (!/^[1-9]\d{0,19}$/.test(String(entry?.id))) return null;
    try {
      const url = new URL(entry.image, baseUrl);
      const ownShopifyCdn = baseUrl && url.origin === new URL(baseUrl).origin && url.pathname.startsWith('/cdn/shop/');
      if (url.protocol !== 'https:' || (!/(^|\.)cdn\.shopify\.com$/.test(url.hostname) && !ownShopifyCdn)) return null;
      return { ...entry, image: url.href };
    } catch (_) { return null; }
  });
  if (!entries.length || entries.some((entry) => !entry)) return null;
  const selected = entries.find((entry) => String(entry.id) === String(selectedId)) || entries[0];
  const opposite = entries.find((entry) => String(entry.id) !== String(selected.id) && new URL(entry.image).pathname !== new URL(selected.image).pathname) || null;
  return { selected, opposite };
}

class OrsoDiscoveryCard extends HTMLElement {
  connectedCallback() {
    if (this.controller) return;
    let choices;
    try { choices = JSON.parse(this.dataset.choices); } catch (_) { return; }
    const primary = this.querySelector('[data-discovery-primary]');
    const secondary = this.querySelector('[data-discovery-secondary]');
    const toggle = this.querySelector('[data-discovery-toggle]');
    const thumb = toggle?.querySelector('img');
    const link = this.querySelector('[data-discovery-link]');
    if (!primary || !secondary || !toggle || !thumb || !link) return;
    const first = discoveryChoicePair(choices, this.dataset.selectedVariant);
    if (!first) return;
    this.controller = new AbortController();
    const { signal } = this.controller;
    let choice = first.selected, opposite = first.opposite, hover = false, focus = false, loaded = false, expected = '';
    const image = (element, source, small = false) => {
      const url = new URL(source);
      const widths = small ? [96, 144] : [160, 240, 320, 480, 600, 900];
      const sized = (width) => { const next = new URL(url); next.searchParams.set('width', String(width)); return next.href; };
      element.srcset = widths.map((width) => `${sized(width)} ${width}w`).join(', ');
      element.sizes = small ? '44px' : '(min-width: 1200px) 20vw, (min-width: 761px) 33vw, 50vw';
      element.src = sized(small ? 96 : 600);
    };
    const update = () => this.toggleAttribute('data-orso-preview-active', loaded && (hover || focus));
    const prepare = () => {
      if (!opposite || expected === opposite.image) return;
      loaded = false; expected = opposite.image; image(secondary, expected);
    };
    const apply = (next, initial = false) => {
      const pair = discoveryChoicePair(choices, next.id);
      if (!pair || String(pair.selected.id) !== String(next.id)) return;
      const target = new URL(this.dataset.productUrl, window.location.origin);
      if (target.origin !== window.location.origin || !target.pathname.includes('/products/')) return;
      target.searchParams.set('variant', pair.selected.id);
      link.href = target.href;
      choice = pair.selected; opposite = pair.opposite; hover = false; focus = false; loaded = false; expected = '';
      this.dataset.selectedVariant = String(choice.id);
      const priceElement = this.querySelector('[data-orso-price]');
      if (priceElement && Number.isFinite(choice.price) && choice.price >= 0 && typeof choice.money === 'string') {
        const nodes = [];
        if (Number.isFinite(choice.compare) && choice.compare > choice.price && typeof choice.compareMoney === 'string') {
          const compared = document.createElement('s');
          compared.dataset.orsoComparePrice = '';
          const amount = document.createElement('bdi');
          amount.textContent = choice.compareMoney;
          compared.append(amount);
          nodes.push(compared, document.createTextNode(' '));
        }
        const current = document.createElement('bdi');
        current.dataset.orsoCurrentPrice = '';
        current.textContent = choice.money;
        nodes.push(current);
        priceElement.replaceChildren(...nodes);
        priceElement.dataset.price = String(choice.price);
        priceElement.dataset.compare = choice.compare == null ? '' : String(choice.compare);
      }
      if (!initial) image(primary, choice.image);
      primary.alt = `${this.dataset.title} - ${choice.alt}`;
      secondary.removeAttribute('srcset'); secondary.removeAttribute('sizes'); secondary.removeAttribute('src');
      toggle.hidden = !opposite;
      if (opposite) {
        image(thumb, opposite.image, true);
        toggle.setAttribute('aria-label', `Selecionar ${opposite.alt.toLowerCase()} de ${this.dataset.title}`);
        toggle.dataset.targetVariant = String(opposite.id);
      }
      update();
    };
    secondary.addEventListener('load', () => {
      if (!expected || secondary.naturalWidth <= 1) return;
      const current = new URL(secondary.currentSrc || secondary.src), wanted = new URL(expected);
      if (current.origin === wanted.origin && current.pathname === wanted.pathname && current.searchParams.get('v') === wanted.searchParams.get('v')) { loaded = true; update(); }
    }, { signal });
    secondary.addEventListener('error', () => { loaded = false; update(); }, { signal });
    this.addEventListener('pointerenter', (event) => { if (event.pointerType !== 'touch') { hover = true; prepare(); update(); } }, { signal });
    this.addEventListener('pointerleave', () => { hover = false; update(); }, { signal });
    this.addEventListener('focusin', () => { focus = true; prepare(); update(); }, { signal });
    this.addEventListener('focusout', () => { queueMicrotask(() => { focus = this.contains(document.activeElement); update(); }); }, { signal });
    toggle.addEventListener('click', (event) => { event.preventDefault(); event.stopPropagation(); if (opposite) apply(opposite); }, { signal });
    apply(choice, true);
  }
  disconnectedCallback() { this.controller?.abort(); this.controller = null; }
}
if (!customElements.get('orso-discovery-card')) customElements.define('orso-discovery-card', OrsoDiscoveryCard);
  } catch(e) { console.error(e); }
})();

})();
